import { eventHub, EVENT_NAMES } from '../../../services/eventService';

const modalGuidebookId = 'guidebook';
const modalPharmacySearchId = 'pharmacy-search';
const modalBranchSelectionId = 'branch-selection';

export default {
    data() {
        return {
            showGuidebookSubmenu: false,
            showPharmacySearchSubmenu: false,
            showPharmacyBranchSelection: false
        };
    },
    methods: {
        closeAllItemsEvent(event) {
            if (event.key === 'Escape') {
                this.closeAllItems();
            }
        },
        onGuidebookItemClick() {
            this.toggleItem(this.showGuidebookSubmenu, modalGuidebookId);
        },
        onPharmacySearchItemClick() {
            this.toggleItem(this.showPharmacySearchSubmenu, modalPharmacySearchId);
        },
        onPharmacyBranchSelectionClick() {
            this.toggleItem(this.showPharmacyBranchSelection, modalBranchSelectionId);
        },
        closeGuidebookItem() {
            if (this.showGuidebookSubmenu) this.toggleItem(this.showGuidebookSubmenu, modalGuidebookId);
        },
        closeAllItems() {
            if (this.showGuidebookSubmenu) this.toggleItem(this.showGuidebookSubmenu, modalGuidebookId);
            if (this.showPharmacySearchSubmenu) this.toggleItem(this.showPharmacySearchSubmenu, modalPharmacySearchId);
            if (this.showPharmacyBranchSelection) this.toggleItem(this.showPharmacyBranchSelection, modalBranchSelectionId);
        },
        toggleItem(state, modalId) {
            eventHub.$emit(EVENT_NAMES[state
                ? 'MODAL_CLOSE'
                : 'MODAL_OPEN'
            ], { modalId, scrollIrrelevant: true });
        },
        filterKeyAndExecute(event, toExecute){
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault(); // Standardverhalten verhindern
                toExecute();
            }
        },
        handleFocusIn(event) {
            if (this.showGuidebookSubmenu && !document.getElementById(modalGuidebookId).contains(event.target)) {
                this.toggleItem(this.showGuidebookSubmenu, modalGuidebookId);
            }
            if (this.showPharmacySearchSubmenu && !document.getElementById(modalPharmacySearchId).contains(event.target)) {
                this.toggleItem(this.showPharmacySearchSubmenu, modalPharmacySearchId);
            }
            if (this.showPharmacyBranchSelection && !document.getElementById(modalBranchSelectionId).contains(event.target)) {
                this.toggleItem(this.showPharmacyBranchSelection, modalBranchSelectionId);
            }
        }

    },
    created() {
        eventHub.$on(EVENT_NAMES.MODAL_OPEN, (payload) => {
            this.showGuidebookSubmenu = (payload.modalId === modalGuidebookId);
            this.showPharmacySearchSubmenu = (payload.modalId === modalPharmacySearchId);
            this.showPharmacyBranchSelection = (payload.modalId === modalBranchSelectionId);
        });

        eventHub.$on(EVENT_NAMES.MODAL_CLOSE, (payload) => {
            this.showGuidebookSubmenu = (payload.modalId === modalGuidebookId)
                ? false
                : this.showGuidebookSubmenu;
            this.showPharmacySearchSubmenu = (payload.modalId === modalPharmacySearchId)
                ? false
                : this.showPharmacySearchSubmenu;
            this.showPharmacyBranchSelection = (payload.modalId === modalBranchSelectionId)
                ? false
                : this.showPharmacyBranchSelection;
        });

        document.addEventListener('keydown', this.closeAllItemsEvent);
        document.addEventListener('focusin', this.handleFocusIn)
    }
};